import ErrorAlert from './ErrorAlert'
import MessageErrorAlert from './MessageErrorAlert'

export { MessageErrorAlert }
export default ErrorAlert
